<template>
    <div class="container my-5">
        <Login @loggedIn="loggedIn"/>
        <InstructorTable v-if="show" v-bind:authorizationToken="authorizationToken"/>
    </div>
</template>

<script>
    import Login from './components/Login.vue'
    import InstructorTable from './components/InstructorTable.vue'

    export default {
        data() {
            return {
                show: false,
                authorizationToken: '',
            }
        },
        components: {
            Login, InstructorTable
        },
        methods: {
            loggedIn(authorizationToken) {
                this.show = (authorizationToken !== '');
                this.authorizationToken = authorizationToken;
            }
        }
    }
</script>